import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import { CheckActionPermission } from "Actions/commonAction";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { instance } from "Actions/AxiosInstance";
import flagIconBlue from "Assets/newicons/object/flag/glyph/default-flag-16px-blue.svg";
import flagIcon from "Assets/newicons/object/flag/glyph/default-flag-16px.svg";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import PageHeader from "Component/Headers/pageHeader";
import Picker from "emoji-picker-react";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DynamicForm from "../../../../../../Component/DynamicForm";

class RatingScale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedscale: null,
      scalenum: null,
      open: false,
      ratings: [
        {
          ratingscaletypeid: 1,
          isdefault: false,
        },
        {
          ratingscaletypeid: 2,
          isdefault: false,
        },
        {
          ratingscaletypeid: 3,
          isdefault: false,
        },
        {
          ratingscaletypeid: 4,
          isdefault: false,
        },
        {
          ratingscaletypeid: 5,
          isdefault: false,
        },
      ],
    };

    this.getData = this.getData.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.setDefault = this.setDefault.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("ratingscale");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getData();

        // if (!this.state.permissions.editable) {
        //   const index = this.state.headers.findIndex(
        //     (x) => x.type == TDTypeConsts.MORE_OPTIONS,
        //   );
        //   if (index != -1) {
        //     this.state.headers.splice(index, 1);
        //   }
        // }
      });
    }
  }

  getData() {
    instance
      .get(`perform/getratingscale`)
      .then((result) => {
        if (result.data.result.length > 0) {
          const onerating = result.data.result.find(
            (x) => x.ratingscaletypeid == 1,
          );
          const tworating = result.data.result.find(
            (x) => x.ratingscaletypeid == 2,
          );
          const threerating = result.data.result.find(
            (x) => x.ratingscaletypeid == 3,
          );
          const ratings = [
            {
              ...onerating,
              threeunicode:
                onerating && onerating.threeunicode
                  ? onerating.threeunicode
                  : "1f603",
              twounicode:
                onerating && onerating.twounicode
                  ? onerating.twounicode
                  : "1f603",
              oneunicode:
                onerating && onerating.oneunicode
                  ? onerating.oneunicode
                  : "1f603",
            },
            {
              ...tworating,
              fourunicode:
                tworating && tworating.fourunicode
                  ? tworating.fourunicode
                  : "1f603",
              threeunicode:
                tworating && tworating.threeunicode
                  ? tworating.threeunicode
                  : "1f603",
              twounicode:
                tworating && tworating.twounicode
                  ? tworating.twounicode
                  : "1f603",
              oneunicode:
                tworating && tworating.oneunicode
                  ? tworating.oneunicode
                  : "1f603",
            },
            {
              ...threerating,
              fiveunicode:
                threerating && threerating.fiveunicode
                  ? threerating.fiveunicode
                  : "1f603",
              fourunicode:
                threerating && threerating.fourunicode
                  ? threerating.fourunicode
                  : "1f603",
              threeunicode:
                threerating && threerating.threeunicode
                  ? threerating.threeunicode
                  : "1f603",
              twounicode:
                threerating && threerating.twounicode
                  ? threerating.twounicode
                  : "1f603",
              oneunicode:
                threerating && threerating.oneunicode
                  ? threerating.oneunicode
                  : "1f603",
            },
            result.data.result.find((x) => x.ratingscaletypeid == 4),
            result.data.result.find((x) => x.ratingscaletypeid == 5),
          ];
          console.log("ratings: ", ratings);
          this.setState({ ratings });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onSelect(e, key) {
    this.setState({ [key]: e.displayvalue });
  }

  onEmojiClick = (value, key, id) => {
    console.log("value, key, id: ", value, key, id);
    const { ratings } = this.state;
    const index = ratings.findIndex((x) => x.ratingscaletypeid == id);
    ratings[index][key] = value.unified;
    console.log("ratings: ", ratings);
    this.setState({
      ratings,
      selectedscale: null,
      scalenum: null,
    });
  };

  setCurrentPage = (option) => {
    this.setState({ currentPage: option });
  };

  handleExpandClick = (event, isExpanded, panel) => {
    console.log("event, isExpanded: ", event, isExpanded);
    console.log("panel: ", panel);
    // setExpanded(isExpanded ? panel : false); // //previous state manager , now not needed //
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false }); // new state manager//
  };

  updateDescription(value, key, id) {
    console.log("value, key, id: ", value, key, id);
    const { ratings } = this.state;
    const index = ratings.findIndex((x) => x.ratingscaletypeid == id);
    ratings[index][key] = value;
    this.setState({
      ratings,
    });
  }

  onSave() {
    instance
      .post(`perform/createratingscale`, { ratingscale: this.state.ratings })
      .then((result) => {
        this.getData();
        this.props.getReviewformdata();
        this.props.enqueueSnackbar("Saved successfully", {
          variant: "success",
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setDefault(id) {
    let { ratings } = this.state;
    ratings = ratings.map((obj, index) => ({
      ...obj,
      isdefault: index == id ? (obj.isdefault == true ? false : true) : false,
    }));
    this.setState({
      ratings,
    });
  }

  render() {
    return (
      <div style={{ paddingBottom: 92 }}>
        {/* <Helmet>
          <title>{headersList.Config.Reminder.header}</title>
        </Helmet> */}

        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div>
              <p className="normal-dark-secondary margin-bottom-16">
                We have prefilled the rating scale for you, feel free to edit
                it. You can select a default scale by clicking the flag 🏁
              </p>
              <ExpansionPanel
                expanded={this.state.expanded === "panel1"}
                onChange={(e, isexpanded) =>
                  this.handleExpandClick(e, isexpanded, "panel1")
                }
                className="rounded-rectangle-paper rounded-rectangle-div padding0"
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Grid container>
                    <Grid item sm={12} md={1}>
                      <Tooltip
                        title={
                          this.state.isDefualt
                            ? "Default rating scale"
                            : "Set as default "
                        }
                        placement="top"
                      >
                        <div
                          className="rating-scale-selector"
                          onClick={(e) => this.setDefault(0)}
                        >
                          <img
                            src={
                              this.state.ratings[0] &&
                              this.state.ratings[0].isdefault
                                ? flagIconBlue
                                : flagIcon
                            }
                            className="vertical-center"
                          ></img>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid item sm={12} md={11}>
                      <p
                        className="normal-dark-secondary margin-left-8"
                        style={{ lineHeight: "34px" }}
                      >
                        3 point rating scale
                      </p>
                    </Grid>
                  </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-0">
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      3 point
                    </p>
                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[0] &&
                            this.state.ratings[0].scalethree,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalethree", 1)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className=" position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 1,
                            scalenum: 3,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[0] &&
                          this.state.ratings[0].threeunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[0] &&
                                this.state.ratings[0].threeunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[0] &&
                                    this.state.ratings[0].threeunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 1 &&
                        this.state.open == true &&
                        this.state.scalenum == 3 && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "threeunicode", 1)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      2 point
                    </p>

                    <div
                      className=" margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[0] &&
                            this.state.ratings[0].scaletwo,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaletwo", 1)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 1,
                            scalenum: 2,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[0] &&
                          this.state.ratings[0].twounicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[0] &&
                                this.state.ratings[0].twounicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[0] &&
                                    this.state.ratings[0].twounicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 1 &&
                        this.state.scalenum == 2 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "twounicode", 1)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      1 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[0] &&
                            this.state.ratings[0].scaleone,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleone", 1)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className=" position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 1,
                            scalenum: 1,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[0] &&
                          this.state.ratings[0].oneunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[0] &&
                                this.state.ratings[0].oneunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[0] &&
                                    this.state.ratings[0].oneunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 1 &&
                        this.state.scalenum == 1 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "oneunicode", 1)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div className="floatright">
                    <p className="extra-small-dark-secondary">
                      Star, number and emoji rating available
                    </p>
                  </div>
                  <div className="clear-float"></div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel
                expanded={this.state.expanded === "panel2"}
                onChange={(e, isexpanded) =>
                  this.handleExpandClick(e, isexpanded, "panel2")
                }
                className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-8"
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Grid container>
                    <Grid item sm={12} md={1}>
                      <Tooltip
                        title={
                          this.state.isDefualt
                            ? "Default rating scale"
                            : "Set as default "
                        }
                        placement="top"
                      >
                        <div
                          className="rating-scale-selector"
                          onClick={() => this.setDefault(1)}
                        >
                          <img
                            src={
                              this.state.ratings[1] &&
                              this.state.ratings[1].isdefault
                                ? flagIconBlue
                                : flagIcon
                            }
                            className="vertical-center"
                          ></img>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid item sm={12} md={11}>
                      <p
                        className="normal-dark-secondary margin-left-8"
                        style={{ lineHeight: "34px" }}
                      >
                        4 point rating scale
                      </p>
                    </Grid>
                  </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-0">
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      4 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[1] &&
                            this.state.ratings[1].scalefour,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefour", 2)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 2,
                            scalenum: 4,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[1] &&
                          this.state.ratings[1].fourunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[1] &&
                                this.state.ratings[1].fourunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[1] &&
                                    this.state.ratings[1].fourunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 2 &&
                        this.state.scalenum == 4 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "fourunicode", 2)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      3 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[1] &&
                            this.state.ratings[1].scalethree,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalethree", 2)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className=" position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 2,
                            scalenum: 3,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[1] &&
                          this.state.ratings[1].threeunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[1] &&
                                this.state.ratings[1].threeunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[1] &&
                                    this.state.ratings[1].threeunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 2 &&
                        this.state.scalenum == 3 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "threeunicode", 2)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      2 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[1] &&
                            this.state.ratings[1].scaletwo,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaletwo", 2)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 2,
                            scalenum: 2,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[1] &&
                          this.state.ratings[1].twounicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[1] &&
                                this.state.ratings[1].twounicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[1] &&
                                    this.state.ratings[1].twounicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 2 &&
                        this.state.scalenum == 2 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "twounicode", 2)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      1 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[1] &&
                            this.state.ratings[1].scaleone,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleone", 2)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 2,
                            scalenum: 1,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[1] &&
                          this.state.ratings[1].oneunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[1] &&
                                this.state.ratings[1].oneunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[1] &&
                                    this.state.ratings[1].oneunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 2 &&
                        this.state.scalenum == 1 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "oneunicode", 2)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div className="floatright">
                    <p className="extra-small-dark-secondary">
                      Star, number and emoji rating available
                    </p>
                  </div>
                  <div className="clear-float"></div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel
                expanded={this.state.expanded === "panel3"}
                onChange={(e, isexpanded) =>
                  this.handleExpandClick(e, isexpanded, "panel3")
                }
                className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-8"
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <Grid container>
                    <Grid item sm={12} md={1}>
                      <Tooltip
                        title={
                          this.state.isDefualt
                            ? "Default rating scale"
                            : "Set as default "
                        }
                        placement="top"
                      >
                        <div
                          className="rating-scale-selector"
                          onClick={() => this.setDefault(2)}
                        >
                          <img
                            src={
                              this.state.ratings[2] &&
                              this.state.ratings[2].isdefault
                                ? flagIconBlue
                                : flagIcon
                            }
                            className="vertical-center"
                          ></img>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid item sm={12} md={11}>
                      <p
                        className="normal-dark-secondary margin-left-8"
                        style={{ lineHeight: "34px" }}
                      >
                        5 point rating scale
                      </p>
                    </Grid>
                  </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-0">
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      5 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[2] &&
                            this.state.ratings[2].scalefive,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefive", 3)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 3,
                            scalenum: 5,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[2] &&
                          this.state.ratings[2].fiveunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[2] &&
                                this.state.ratings[2].fiveunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[2] &&
                                    this.state.ratings[2].fiveunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 3 &&
                        this.state.scalenum == 5 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "fiveunicode", 3)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>

                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      4 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[2] &&
                            this.state.ratings[2].scalefour,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefour", 3)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 3,
                            scalenum: 4,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[2] &&
                          this.state.ratings[2].fourunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[2] &&
                                this.state.ratings[2].fourunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[2] &&
                                    this.state.ratings[2].fourunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 3 &&
                        this.state.scalenum == 4 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "fourunicode", 3)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      3 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[2] &&
                            this.state.ratings[2].scalethree,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalethree", 3)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className="position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 3,
                            scalenum: 3,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[2] &&
                          this.state.ratings[2].threeunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[2] &&
                                this.state.ratings[2].threeunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[2] &&
                                    this.state.ratings[2].threeunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 3 &&
                        this.state.scalenum == 3 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "threeunicode", 3)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      2 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[2] &&
                            this.state.ratings[2].scaletwo,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaletwo", 3)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className=" position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 3,
                            scalenum: 2,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[2] &&
                          this.state.ratings[2].twounicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[2] &&
                                this.state.ratings[2].twounicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[2] &&
                                    this.state.ratings[2].twounicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 3 &&
                        this.state.scalenum == 2 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "twounicode", 3)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      1 point
                    </p>

                    <div
                      className="margin-right-16 width70"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[2] &&
                            this.state.ratings[2].scaleone,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleone", 3)
                        }
                        formKey="description"
                      />
                    </div>
                    <div className=" position-rel">
                      <div
                        className="emoji-picker floatright cursor-pointer"
                        onClick={() =>
                          this.setState({
                            selectedscale: 3,
                            scalenum: 1,
                            open: true,
                          })
                        }
                      >
                        <div
                          className="vertical-center"
                          style={{ height: 20, width: 22 }}
                        >
                          {this.state.ratings[2] &&
                          this.state.ratings[2].oneunicode &&
                          !isNaN(
                            parseInt(
                              this.state.ratings[2] &&
                                this.state.ratings[2].oneunicode,
                              16,
                            ),
                          ) ? (
                            <p className="normal-dark">
                              {String.fromCodePoint(
                                parseInt(
                                  this.state.ratings[2] &&
                                    this.state.ratings[2].oneunicode,
                                  16,
                                ),
                              )}
                            </p>
                          ) : (
                            <p className="normal-dark">😃</p>
                          )}
                        </div>
                      </div>
                      {this.state.selectedscale &&
                        this.state.scalenum &&
                        this.state.selectedscale == 3 &&
                        this.state.scalenum == 1 &&
                        this.state.open == true && (
                          <ClickAwayListener
                            onClickAway={() => this.setState({ open: false })}
                          >
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: 48,
                                zIndex: 1,
                              }}
                              // onBlur={() => this.setState({ emojiPicker: false })}
                            >
                              <Picker
                                onEmojiClick={(e, obj) =>
                                  this.onEmojiClick(obj, "oneunicode", 3)
                                }
                              />
                            </div>
                          </ClickAwayListener>
                        )}
                    </div>
                  </div>
                  <div className="floatright">
                    <p className="extra-small-dark-secondary">
                      Star, number and emoji rating available
                    </p>
                  </div>
                  <div className="clear-float"></div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel
                expanded={this.state.expanded === "panel4"}
                onChange={(e, isexpanded) =>
                  this.handleExpandClick(e, isexpanded, "panel4")
                }
                className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-8"
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Grid container>
                    <Grid item sm={12} md={1}>
                      <Tooltip
                        title={
                          this.state.isDefualt
                            ? "Default rating scale"
                            : "Set as default "
                        }
                        placement="top"
                      >
                        <div
                          className="rating-scale-selector"
                          onClick={() => this.setDefault(3)}
                        >
                          <img
                            src={
                              this.state.ratings[3] &&
                              this.state.ratings[3].isdefault
                                ? flagIconBlue
                                : flagIcon
                            }
                            className="vertical-center"
                          ></img>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid item sm={12} md={11}>
                      <p
                        className="normal-dark-secondary margin-left-8"
                        style={{ lineHeight: "34px" }}
                      >
                        7 point rating scale
                      </p>
                    </Grid>
                  </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-0">
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      7 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scaleseven,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleseven", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      6 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scalesix,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalesix", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      5 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scalefive,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefive", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      4 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scalefour,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefour", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      3 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scalethree,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalethree", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      2 point
                    </p>

                    <div className="width80" style={{ marginBottom: -16 }}>
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scaletwo,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaletwo", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      1 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[3] &&
                            this.state.ratings[3].scaleone,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleone", 4)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div className="floatright">
                    <p className="extra-small-dark-secondary">
                      Only number rating available in this rating scale.
                    </p>
                  </div>
                  <div className="clear-float"></div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel
                expanded={this.state.expanded === "panel5"}
                onChange={(e, isexpanded) =>
                  this.handleExpandClick(e, isexpanded, "panel5")
                }
                className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-8"
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel5bh-content"
                  id="panel5bh-header"
                >
                  <Grid container>
                    <Grid item sm={12} md={1}>
                      <Tooltip
                        title={
                          this.state.isDefualt
                            ? "Default rating scale"
                            : "Set as default "
                        }
                        placement="top"
                      >
                        <div
                          className="rating-scale-selector"
                          onClick={() => this.setDefault(4)}
                        >
                          <img
                            src={
                              this.state.ratings[4] &&
                              this.state.ratings[4].isdefault
                                ? flagIconBlue
                                : flagIcon
                            }
                            className="vertical-center"
                          ></img>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid item sm={12} md={11}>
                      <p
                        className="normal-dark-secondary margin-left-8"
                        style={{ lineHeight: "34px" }}
                      >
                        10 point rating scale
                      </p>
                    </Grid>
                  </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-0">
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      10 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scaleten,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleten", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      9 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scalenine,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalenine", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      8 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scaleeight,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleeight", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      7 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scaleseven,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleseven", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      6 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scalesix,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalesix", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      5 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scalefive,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefive", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      4 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scalefour,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalefour", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      3 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scalethree,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scalethree", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      2 point
                    </p>

                    <div
                      item
                      sm={12}
                      md={8}
                      className="width80"
                      style={{ marginBottom: -16 }}
                    >
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scaletwo,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaletwo", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-right-16">
                      1 point
                    </p>

                    <div className="width80">
                      <DynamicForm
                        fields={textinputconverter({
                          value:
                            this.state.ratings[4] &&
                            this.state.ratings[4].scaleone,
                          label: "",
                          placeholder: "define this rating",
                          disabled:
                            this.state.permissions &&
                            !this.state.permissions.editable,
                        })}
                        onChange={(e) =>
                          this.updateDescription(e, "scaleone", 5)
                        }
                        formKey="description"
                      />
                    </div>
                  </div>
                  <div className="floatright">
                    <p className="extra-small-dark-secondary">
                      Only number rating available in this rating scale.
                    </p>
                  </div>
                  <div className="clear-float"></div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Grid>
        </Grid>
        {this.state.permissions && this.state.permissions.editable && (
          <div
            className="width40"
            style={{
              position: "fixed",
              right: 8,
              background: "white",
              bottom: 0,
              padding: 10,
              borderTop: "1px solid #d4d4d4",
              zIndex: 0,
            }}
          >
            <div>
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                onClick={this.onSave}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(RatingScale));
